export function enumValues(definition) {
  const values = Object.keys(definition).map(key => definition[key]);
  return values.filter(value => typeof value === 'string') as string[];
}



// WEBPACK FOOTER //
// ./src/app/shared/util/enumValues.ts